import {
  MLAApplicationComment,
  MLAApplicationStatus
} from '../hooks/useGetMLAApplicationList';

export type PutMLAApplicationStatusSuccessResponse = {
  id: number;
  status: MLAApplicationStatus;
  comment: MLAApplicationComment;
};

export type PutMLAApplicationStatusErrorResponse = {
  status_code: number;
  message: string;
  errors: Record<string, string[]>;
};

export type PutMLAApplicationStatusResponse =
  PutMLAApplicationStatusSuccessResponse | PutMLAApplicationStatusErrorResponse;

export const isPutMLAApplicationStatusError = (
  response: PutMLAApplicationStatusResponse
): response is PutMLAApplicationStatusErrorResponse => (
  'status_code' in response &&
  (response.status_code >= 300 || response.status_code < 200)
);

export const isPutMLAApplicationStatusSuccess = (
  response: PutMLAApplicationStatusResponse
): response is PutMLAApplicationStatusSuccessResponse => (
  'id' in response &&
  typeof response.id === 'number' &&
  typeof response.status === 'number'
);
